import { Box } from '@chakra-ui/react'
import { Remarkable } from 'remarkable'

const EULA = ({ eula }) => {
  return <Box className='box markdown' w='75%' dangerouslySetInnerHTML={{ __html: new Remarkable().render(eula) }} />
}

export default EULA
